import {useEffect, useState} from "react";

export const useCookieBotObserver = () => {
    const [isCookieBotOpen, setIsCookieBotOpen] = useState(false);

    const onCookieBotOpen = () => {
        setIsCookieBotOpen(true);
    };

    const onCookieBotClose = () => {
        setIsCookieBotOpen(false);
    };

    useEffect(() => {
        if (window) {
            window.addEventListener("CookiebotOnDialogDisplay", onCookieBotOpen);
            window.addEventListener("CookiebotOnAccept", onCookieBotClose);
            window.addEventListener("CookiebotOnDecline", onCookieBotClose);
        }

        return () => {
            if (window) {
                window.removeEventListener("CookiebotOnDialogDisplay", onCookieBotOpen);
                window.removeEventListener("CookiebotOnAccept", onCookieBotClose);
                window.removeEventListener("CookiebotOnDecline", onCookieBotClose);
            }
        };
    }, []);

    return {isCookieBotOpen};
};
import {useEffect, useState} from "react";

export const useCookieBotObserver = () => {
    const [isCookieBotOpen, setIsCookieBotOpen] = useState(false);

    const onCookieBotOpen = () => {
        setIsCookieBotOpen(true);
    };

    const onCookieBotClose = () => {
        setIsCookieBotOpen(false);
    };

    useEffect(() => {
        if (window) {
            window.addEventListener("CookiebotOnDialogDisplay", onCookieBotOpen);
            window.addEventListener("CookiebotOnAccept", onCookieBotClose);
            window.addEventListener("CookiebotOnDecline", onCookieBotClose);
        }

        return () => {
            if (window) {
                window.removeEventListener("CookiebotOnDialogDisplay", onCookieBotOpen);
                window.removeEventListener("CookiebotOnAccept", onCookieBotClose);
                window.removeEventListener("CookiebotOnDecline", onCookieBotClose);
            }
        };
    }, []);

    return {isCookieBotOpen};
};
